import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createRealEstateEvent,
  deleteRealEstateEvent,
  updateRealEstateEvent,
} from '../mutations/realEstateEvents.mutations'
import {
  fetchRealEstateEvents,
  type RealEstateEventResponse,
} from '../queries/realEstateEvents.queries'

export const useRealEstateEvents = () =>
  useQuery({
    queryKey: ['real-estate-events'],
    queryFn: fetchRealEstateEvents,
  })

export const useCreateRealEstateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createRealEstateEvent,
    onSuccess: (newEvent) => {
      queryClient.setQueryData<RealEstateEventResponse[]>(['real-estate-events'], (old) => {
        if (!old) return [newEvent]
        return [...old, newEvent]
      })

      queryClient.invalidateQueries({ queryKey: ['real-estate-events'] })
    },
  })
}

export const useUpdateRealEstateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateRealEstateEvent,
    onSuccess: (updatedEvent) => {
      queryClient.setQueryData<RealEstateEventResponse[]>(['real-estate-events'], (old) => {
        if (!old) return old
        return old.map((event) => (event.id === updatedEvent.id ? updatedEvent : event))
      })

      queryClient.invalidateQueries({ queryKey: ['real-estate-events'] })
    },
  })
}

export const useDeleteRealEstateEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteRealEstateEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['real-estate-events'] })
    },
  })
}
